import { Component, OnInit } from '@angular/core';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { ModalService } from '../../modal.service';

@Component({
  selector: 'shell-without-dpf',
  templateUrl: './without-dpf.component.html',
})
export class WithoutDpfComponent implements OnInit {
  constructor(
    private microFrontendRouter: MicroFrontendRouter,
    public modalService: ModalService,
    private messageBusService: MessageBusService,
  ) {}

  ngOnInit() {}

  closeModal() {
    this.messageBusService.emit('shell', 'footer.type', 'DEFAULT');
    this.microFrontendRouter.navigateByUrl('/inicio', 'inicio');
    this.modalService.close();
  }
}
